import React, { useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import { Checkbox } from "../../../view/Checkbox";
import { deepCopy, sortObjectsByAlphabet } from "../../../utils";
import ModalListTable from "../../../view/ModalListTable";

export function RemoveTargetTypeModal({ setShowModal, elements = [], onSubmit, title, text, onBack }) {

    const [selected, setSelected] = useState([]);

    const onClick = (element) => {

        const copy = deepCopy(selected);
        const existedElement = copy.find(el => el.id === element.id);

        if (existedElement) {
            copy.splice(copy.indexOf(existedElement), 1);
            setSelected(copy);
        } else {
            copy.push(element);
            setSelected(copy);
        }
    };

    const isActive = (element) => !!selected.find(el => el.id === element.id);

    const sortedElements = sortObjectsByAlphabet(elements, "name");
    const columns = [
        {
            key: "selected",
            label: "",
            className: "target-type-picker-modal__checkbox",
            headerClassName: "target-type-picker-modal__checkbox",
            render: (element) => (
                <div onClick={(event) => event.stopPropagation()}>
                    <Checkbox checked={isActive(element)} onClick={() => onClick(element)} />
                </div>
            )
        },
        {
            key: "name",
            label: text,
            className: "target-type-picker-modal__name",
            searchValue: (element) => element.name,
            render: (element) => element.name
        }
    ];

    return (
        <div className="modal oct_display-block modal-v2-root">
            <div className="modal oct_modal modal-v2-overlay">
                <div className="modal-dialog modal-dialog-centered modal-v2-dialog target-type-picker-modal" aria-modal="true">
                    <div className="modal-content modal-v2-shell target-type-picker-modal">
                        <div className="modal-v2-header">
                            <div className="modal-v2-header-top">
                                <div className="modal-v2-header-copy">
                                    <h2 className="modal-v2-heading">{title}</h2>
                                    <p className="target-type-picker-modal__subtitle">{text}</p>
                                </div>
                            </div>
                            <button
                                type="button"
                                className="modal-v2-close"
                                aria-label="Close"
                                onClick={() => setShowModal(false)}
                            >
                                <span aria-hidden="true"><CloseIcon /></span>
                            </button>
                        </div>
                        <div className="modal-body modal-v2-body target-type-picker-modal__body">
                            <ModalListTable
                                items={sortedElements}
                                columns={columns}
                                variant="schedule"
                                searchPlaceholder="Search..."
                                emptyMessage="No entries found."
                                noResultsMessage="No matching entries found."
                                getSearchValue={(element) => element.name || ""}
                                onRowClick={onClick}
                                getRowClassName={(element) => isActive(element) ? "oct_modal-list__row--selected" : ""}
                                hideHeaderWhenEmpty={true}
                                hidePaginationWhenEmpty={true}
                            />
                        </div>
                        <div className="modal-footer modal-v2-footer target-type-picker-modal__footer">
                            <div className="modal-v2-footer-note"></div>
                            <div className="modal-v2-footer-actions">
                                {typeof onBack === "function" ? (
                                    <button
                                        type="button"
                                        className="modal-v2-btn modal-v2-btn-outline"
                                        onClick={onBack}
                                    >
                                        Back
                                    </button>
                                ) : null}
                                <button
                                    type="button"
                                    className="modal-v2-btn modal-v2-btn-outline"
                                    onClick={() => setShowModal(false)}
                                >
                                    Cancel
                                </button>
                                <button
                                    type="button"
                                    className="modal-v2-btn modal-v2-btn-primary"
                                    onClick={() => onSubmit(selected)}
                                    disabled={selected.length === 0}
                                >
                                    Remove
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
